import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/layout.vue'
import NoResult from './components/404.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'mobile',
      component: Layout,
      // redirect: { name: 'home' },
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('./views/home.vue'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'home',
          name: 'the_home',
          component: () => import('./views/home.vue'),
          redirect: { name: 'home' },
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'ppwc',
          name: 'events',
          component: () => import('./views/events.vue'),
          meta: {
            keepAlive: true
          },
          // children: [
          //   { path: 'home', name: 'upcoming-home', component: () => import('./views/eventsHome.vue')},
          //   // { path: 'activate', name: 'upcoming-activate', component: () => import('./views/eventsActivate.vue')}
          // ]
        },

        {
          path: 'activate', name: 'upcoming-activate', redirect: { name: 'upcoming-activate-step1' }, component: () => import('./views/eventsActivate.vue'), children: [
            { path: 'step1', name: 'upcoming-activate-step1', component: () => import('./views/activate/signForm1.vue') },
            {
              path: 'step2', name: 'upcoming-activate-step2', meta: {
                keepAlive: true
              }, component: () => import('./views/activate/signForm2.vue')
            },
            { path: 'step3', name: 'upcoming-activate-step3', component: () => import('./views/activate/signTable.vue') },
            { path: 'step4', name: 'upcoming-activate-step4', component: () => import('./views/activate/signStep4.vue') },
            { path: 'step5', name: 'upcoming-activate-step5', component: () => import('./views/activate/signedTable.vue') },
          ]
        },

        {
          path: 'activate', name: 'upcoming-activate-dec', component: () => import('./views/eventsActivate.vue'), children: [
            { path: ':dec', name: 'upcoming-activate-dec-step1', component: () => import('./views/activate/signForm1.vue') }
          ]
        },

        { path: 'events/ppwc/:item', name: 'events-ppwc', component: () => import('./views/eventsPpwc.vue') },
        { path: 'events/schedule/:item', name: 'events-schedule', component: () => import('./views/eventsSchedule.vue') },
        { path: 'festival', name: 'festival', component: () => import('./views/festival.vue') },
        { path: 'festival/upcoming/:index', name: 'festival-upcoming', component: () => import('./views/festivalUpcoming.vue') },
        { path: 'festival/past/:id', name: 'festival-past', component: () => import('./views/festivalPast.vue') },
        {
          path: 'blog',
          name: 'blog',
          component: () => import('./views/blog.vue'),
          meta: {
            keepAlive: true
          }
        },
        { path: 'blog/:item', name: 'blog-item', component: () => import('./views/blogItem.vue') },
        { path: 'about', name: 'about', component: () => import('./views/about.vue') },
        { path: 'brand', name: 'brand', component: () => import('./views/brand.vue') },
        { path: 'legal-affairs/Privacy', name: 'legalPrivacy', component: () => import('./views/legalPrivacy.vue') },
        { path: 'legal-affairs/Terms', name: 'legalTerms', component: () => import('./views/legalTerms.vue') },
        { path: 'legal-affairs/Unsolicited', name: 'legalUnsolicited', component: () => import('./views/legalUnsolicited.vue') },
        { path: 'legal-affairs/Community', name: 'legalCommunity', component: () => import('./views/legalCommunity.vue') },
        { path: 'legal-affairs/Cookies', name: 'legalCookies', component: () => import('./views/legalCookies.vue') },
        { path: 'legal-affairs/Public', name: 'legalPublic', component: () => import('./views/legalPublic.vue') },
        // {
        //   path: '/faq',
        //   name: 'faq',
        //   component: () => import('./views/faq.vue')
        // },
        // {
        //   path: '/faq/:item',
        //   name: 'item',
        //   component: () => import('./views/faqItem.vue')
        // },
        // {
        //   path: '/faq/:item/:answer/:position',
        //   name: 'answer',
        //   component: () => import('./views/faqAnswer.vue')
        // }
      ]
    },
    { path: '/privacy-policy', name: 'privacy-policy', component: () => import('./views/privacyPolicy.vue') },
    { path: '/user-agreement', name: 'user-agreement', component: () => import('./views/userAgreement.vue') },
    {
      path: '*',
      name: 'NoResult',
      component: Layout,
      redirect: { name: 'NoResult' },
      children: [
        { path: '', name: 'NoResult', component: NoResult },
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.hash) {
    const path = to.path + to.hash.replace("#/", "")
    next(path)
  }
  next()
})

export default router
